import { useMutation } from "@tanstack/react-query";
import { manualSubscribe, ManualSubscribePayload } from "@/api/services/manualSubscription";
import { errorCallback } from "@/api/hooks/error";

export function useManualSubscription() {
    return useMutation({
        mutationFn: (payload: ManualSubscribePayload) => manualSubscribe(payload),
        onError: errorCallback,
    });
}
